module.exports = __webpack_public_path__ + "media/stylesheets/images/main/eventImage/eventImage_pc-a4339cc6b013d2720808b8e98d9ed819.png";